export const USPVariantBModuleName = 'USP Variant B';
